<template>
  <div class="ywb-about flex-col-center">
    <div class="about-head flex-col-center">
      <p>我们服务的愿景</p>
      <p>让智能化更简单</p>
    </div>
    <div class="introduction ">
      <p class="app-title">
        四川迈希沃网络科技有限公司|迈希沃科技
      </p>
      <p class="int-info">
        四川迈希沃网络科技有限公司(迈希沃科技)位于四川省成都市中国科学院成都分院内。我们专注于弱电系统集成、建筑智能化、智能化软件开发等。
      </p>
      <p class="int-info">
        2021年我们上线 “迈希沃网络产品订购平台”小程序，成功打通 “销售”、“产品”、“客户”三个环节的信息壁垒，实现公司业务数据化转型。
      </p>
      <p class="int-info">
        2021年-2025年期间是我们第一个五年发展规划阶段 ，我们将以成都为中心建立覆盖川、渝、云、贵、藏四省一市的合作商体系，竭诚为各个行业提供专业的弱电智能化解决方案。
      </p>
    </div>
    <div class="advisory">
      <p class="app-title" style="font-size:24px;font-weight: 500">
        合作咨询
      </p>
      <div class="flex-center" style="color:#515a65;font-size: 16px;">
        <div class="flex-col-center adv-item">
          <img src="../../assets/user_blank.png"/>
          <p class="adv-item-text">倪经理<br><span>15208167863</span></p>
        </div>
        <div class="flex-col-center adv-item">
          <img src="../../assets/user_blank.png"/>
          <p class="adv-item-text">缪经理<br><span>19950159778</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "about",
    }
</script>

<style scoped>
  @import "../../style.css";
  @import "about_pc.css";
  @import "about_mini.css";
</style>



// WEBPACK FOOTER //
// src/components/about/about.vue